// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* 分页器颜色，不可写入scope */\n.el-pagination.is-background .el-pager li:not(.disabled).active {\n  background-color: #cd0101;\n  color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
